<template>
    <el-skeleton :rows="12" :loading="loading" animated>
        <template #default>
            <div class="row m-0 p-2 justify-content-center">
                <img v-if="uri" :src="uri" class="col-8" />
            </div>
            <input type="file" name="file" ref="fileInput" @change="selectImage" />
            <el-form ref="formRef" :disabled="loading" :rules="rules" :model="adBanner" label-position="top">
                <el-form-item prop="title" label="Titulo / Nome">
                    <el-input name="name" v-model="adBanner.title" />
                </el-form-item>

                <el-form-item prop="expires_at" label="Expira em">
                    <el-date-picker type="datetime" name="expires_at" v-model="adBanner.expires_at" />
                </el-form-item>

                <el-form-item prop="position" label="Ordem (posicao)">
                    <el-input-number :min="0" v-model="adBanner.position" name="position" />
                </el-form-item>

                <el-form-item prop="small_text" label="Texto curto / preco">
                    <el-input name="small_text" v-model="adBanner.small_text" />
                </el-form-item>
                
                <el-form-item prop="url" label="Link">
                    <el-input name="url" v-model="adBanner.url" />
                </el-form-item>
                
                <el-form-item prop="description" label="Descricao">
                    <el-input name="description" type="textarea" v-model="adBanner.description" />
                </el-form-item>
        
                <el-button plain :loading="loading" size="large" type="primary" @click.prevent="submit(formRef)">
                    Cadastrar
                </el-button>
            </el-form>

        </template>
    </el-skeleton>
</template>

<script lang="ts" setup>
    import Api from "@/services/api"
    import { AdBanner } from "@/services/types/adBanner"
    import { ElDatePicker, ElInputNumber, ElMessage, ElMessageBox, FormInstance, FormRules } from "element-plus"
    import { computed, onBeforeMount, reactive, ref } from "vue"
    import { useRouter } from "vue-router"
    import { useStore } from "vuex"

    const store = useStore()
    const router = useRouter()
    const adBanner = reactive<AdBanner>({
        title: '',
        description: '',
        expires_at: new Date(),
        position: 1,
        small_text: '',
        id: 1,
        url: '',
    })

    const rules = reactive<FormRules<AdBanner>>({
        title: [{required: true, message: 'Insira o titulo', min: 1}],
        description: [{required: true, message: 'Informe a descricao'}],
        position: [{required: true, message: 'Posicao'}],
    })

    const fileInput = ref<HTMLInputElement>()
    const image = ref<File | Blob>()
    const formRef = ref<FormInstance>()
    const loading = ref<boolean>(true)

    onBeforeMount(async () => {
        loading.value = true
        
        loading.value = false
    })

    const uri = computed<string | undefined>(() => image.value && URL.createObjectURL(image.value))

    const selectImage = (e: Event) => {
        const target = e.target as HTMLInputElement
        if (target.files) {
            image.value = target.files[0]
        }
    }

    const submit = async (formEl: FormInstance | undefined) => {
        if (!formEl) { return }
        if (!image.value) {
            alert("Selecione imagem")
            return
        }
        await formEl.validate(async (valid) => {
            if (valid) {
                loading.value = true
                const data = new FormData()
                data.append('title', adBanner.title)
                image.value && data.append('image', image.value)
                data.append('description', adBanner.description)
                data.append('expires_at', adBanner.expires_at.toISOString())
                data.append('position', adBanner.position.toString())
                adBanner.small_text && data.append('small_text', adBanner.small_text)
                adBanner.url && data.append('url', adBanner.url)

                const res = await Api.post('admin/ad-banners', adBanner, data)
                console.log(res.data)
                if (res.status == 200) {
                    ElMessage.success({message: 'Propaganda cadastrada com sucesso'})
                    store.commit('setOpenModal', -1)
                    
                } else if (res.status == 422) {
                    if (res.data.errors) {
                        for(let err in res.data.errors) {
                            ElMessage.error({message: res.data.errors[err].join(', ')})
                        }
                    }
                } else {
                    ElMessage.error({message: 'Ocorreu um erro ' + res.data.message})
                }
                loading.value = false
            }
        })
    }
</script>

<!-- <style lang="scss">
    .locate-btn {
        
    }
</style> -->
